import { registrationSlugFromPath } from "../event-registration";
import { publicTrackingDocument } from "./tracking-policy";

/** UX only: server handlers still independently verify every credential. */
export function memberDocumentNavigation(documentPathname: string | undefined, authenticated: boolean): boolean {
  return authenticated && documentPathname !== undefined &&
    !publicTrackingDocument(documentPathname) &&
    registrationSlugFromPath(documentPathname) === null &&
    documentPathname.replace(/\/+$/, "") !== "/mh";
}

export function memberNavigationRequiresReload(documentPathname: string | undefined, destination: string, authenticated: boolean): boolean {
  // The calendar needs its own frame permissions, even in an untracked member document.
  return !memberDocumentNavigation(documentPathname, authenticated) || destination.replace(/\/+$/, "") === "/mh";
}